export default __webpack_public_path__ + "static/media/SeptDom2023.850d6c92.png";